module.exports = __webpack_public_path__ + "static/media/bgillust.ba243386.webp";